export const setCanvasSize = (canvas, { width, height } = {}) => {
  canvas.width = width || window.innerWidth;
  canvas.height = height || window.innerHeight;
  canvas.style.width = "100%";
};

export const setCanvasScale = (canvas, ctx) => {
  const scale = 1; //window.innerHeight < 250 ? 0.6 : 1;
  ctx.transform(scale, 0, 0, -scale, canvas.width / 2, canvas.height / 2);
};

export const createCanvas = container => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  setCanvasSize(canvas);
  setCanvasScale(canvas, ctx);

  container.appendChild(canvas);

  return canvas;
};
